class FacebookTracker {
  constructor() {
    this.fbclid = this.getParam("fbclid");
    this.fbp = this.getCookie("_fbp");
    this.fbc = this.getCookie("_fbc");

    this.setupCookies();
    this.refreshFbpAfterPixelLoaded();
  }

  // === 公用方法 ===
  getFbp() {
    return this.fbp || this.getCookie("_fbp");
  }

  getFbc() {
    return this.fbc || this.getCookie("_fbc");
  }

  /**
   * 自動綁定 click 事件，根據指定 class 觸發對應 Facebook Pixel 標準事件
   * 預設支援：
   *  - .js-fbq-contact-trigger → Contact
   *  - .js-fbq-lead-trigger → Lead
   */
  setupClickEventBindings() {
    if (typeof fbq !== "function") {
      console.warn("[FacebookTracker] fbq() not available, skip DOM event binding");
      return;
    }

    const clickTriggers = [
      { selector: ".js-fbq-contact-trigger", event: "Contact" },
      { selector: ".js-fbq-lead-trigger", event: "Lead" },
    ];

    clickTriggers.forEach(({ selector, event }) => {
      document.querySelectorAll(selector).forEach(el => {
        el.addEventListener("click", () => {
          this.safeFbq("track", event);
        });
      });
    });
  }

  /**
   * 發送 Facebook Pixel PageView 事件
   * 一般建議在每頁首次進入時觸發
   */
  trackPageView() {
    this.safeFbq("track", "PageView");
  }

  /**
   * 發送 Facebook Pixel ViewContent 事件（商品詳情頁）
   * @param {Object} options
   * @param {String} options.content_name - 商品名稱
   * @param {Array<String>} options.content_ids - 商品 ID 陣列（如 SKU）
   * @param {String} [options.content_type="product"] - 商品類型（預設為 product）
   * @param {Number} options.value - 價格金額
   * @param {String} [options.currency="TWD"] - 幣別（預設 TWD）
   */
  trackViewContent({ content_name, content_ids, content_type = "product", value, currency = "TWD" }) {
    this.safeFbq("track", "ViewContent", {
      content_name,
      content_ids,
      content_type,
      value,
      currency,
    });
  }

  /**
   * 發送 Facebook Pixel AddToCart 事件（加入購物車）
   * @param {Object} options
   * @param {Array<String>} options.content_ids - 商品 ID 陣列（如 SKU、variant ID）
   * @param {String} [options.content_type="product"] - 商品類型（如 product、design）
   * @param {Number} options.value - 加入購物車的總金額
   * @param {String} [options.currency="TWD"] - 幣別，預設為 'TWD'
   */
  trackAddToCart({ content_ids, content_type="product", value, currency="TWD" }) {
    this.safeFbq("track", "AddToCart", {
      content_ids,
      content_type,
      value,
      currency,
    });
  }

  /**
   * 發送 Facebook Pixel InitiateCheckout 事件（點擊結帳）
   * @param {Object} options
   * @param {Array<String>} options.content_ids - 商品 ID 陣列（如 SKU、variant ID）
   * @param {String} [options.content_type="product"] - 商品類型（如 product、design）
   * @param {Number} options.value - 結帳金額
   * @param {String} [options.currency="TWD"] - 幣別，預設為 'TWD'
   */
  trackInitiateCheckout({ content_ids, content_type = "product", value, currency = "TWD" }) {
    this.safeFbq("track", "InitiateCheckout", {
      content_ids,
      content_type,
      value,
      currency,
    });
  }

  /**
   * 發送 Facebook Pixel Purchase 事件（購買完成）
   * @param {Object} options
   * @param {Array<String>} options.content_ids - 購買的商品 ID 陣列
   * @param {String} [options.content_type="product"] - 商品類型
   * @param {Number} options.value - 訂單總金額
   * @param {String} [options.currency="TWD"] - 幣別
   */
  trackPurchase({ content_ids, content_type = "product", value, currency = "TWD" }) {
    this.safeFbq("track", "Purchase", {
      content_ids,
      content_type,
      value,
      currency,
    });
  }




  // === 私用工具 ===

  safeFbq(...args) {
    if (typeof fbq === "function") {
      fbq(...args);
    } else {
      console.warn("[FacebookTracker] fbq() not available", args);
    }
  }

  getParam(paramName) {
    const url = new URL(window.location.href);
    return url.searchParams.get(paramName);
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
    return match ? match[1] : null;
  }

  setCookie(name, value, days = 90) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  }

  // generateRandomFbc() {
  //   const timestamp = Math.floor(Date.now() / 1000);
  //   const random = Math.random().toString(36).substring(2, 10);
  //   return `fb.1.${timestamp}.${random}`;
  // }

  setupCookies() {
    // fbc from fbclid
    if (this.fbclid && !this.fbc) {
      this.fbc = `fb.1.${Math.floor(Date.now() / 1000)}.${this.fbclid}`;
      this.setCookie("_fbc", this.fbc);
    // } else if (!this.fbc) {
    //   this.fbc = this.generateRandomFbc();
    //   this.setCookie("_fbc", this.fbc);
    }

    // fbp fallback
    if (!this.fbp) {
      const timestamp = Math.floor(Date.now() / 1000);
      const random = Math.random().toString(36).substring(2, 10);
      this.fbp = `fb.1.${timestamp}.${random}`;
      this.setCookie("_fbp", this.fbp);
    }

    // Clean fbclid from URL
    if (this.fbclid) {
      const url = new URL(window.location.href);
      url.searchParams.delete("fbclid");
      window.history.replaceState({}, document.title, url.pathname + url.search);
    }
  }

  refreshFbpAfterPixelLoaded() {
    setTimeout(() => {
      const realFbp = this.getCookie("_fbp");
      if (realFbp && realFbp !== this.fbp) {
        this.fbp = realFbp;
        this.setCookie("_fbp", realFbp);
      }
    }, 3000);
  }
}

const facebookTracker = new FacebookTracker();
export default facebookTracker;
